import every from 'lodash/every';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import head from 'lodash/head';
import includes from 'lodash/includes';
import isNumber from 'lodash/isNumber';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import round from 'lodash/round';
import size from 'lodash/size';
import trim from 'lodash/trim';
import { FormikFields, OTHER_REASON_CODE, PDF_FILE_NAME, StepRoutes, stepsOrder, } from './constants';
export function isReturnFormEmpty(props) {
    return !props.webToCaseUrl || !props.yourOrder.returnPolicy || !props.heroImage;
}
export const getBackStepRouteName = (currentStep) => {
    const currentStepIndex = findIndex(stepsOrder, (step) => includes(currentStep, step));
    return currentStepIndex > 0 ? stepsOrder[currentStepIndex - 1] : null;
};
export const getStepNumber = (currentStep) => {
    const currentStepIndex = findIndex(stepsOrder, (step) => includes(currentStep, step));
    return currentStepIndex + 1;
};
export const showStepsNavBar = (routeName) => includes(stepsOrder, routeName);
export const removeHashCharacter = (routeName) => head(routeName?.match(/[^#]+/g));
export const addDataToReturnedFormItems = (returnedFormItems, parcelItems) => {
    return map(returnedFormItems, ({ sku, returnReasonCode, returnReasonText, returnReasonOther, returnQuantity }) => {
        const itemFromEntries = find(parcelItems, {
            sku,
        });
        return {
            ...itemFromEntries,
            returnReasonCode,
            returnReasonText,
            returnReasonOther,
            returnQuantity,
        };
    });
};
const shouldAddShippingCost = (parcels, items) => size(parcels) === 1 &&
    every(items, ({ quantity, returnQuantity }) => quantity === returnQuantity);
export const getEurosFromCentAmount = (centAmount) => centAmount / 100;
export const getReimbursement = (parcels, items, shippingCost) => {
    const subtotal = reduce(items, (acc, { price: { centAmount }, returnQuantity }) => {
        return acc + centAmount * returnQuantity;
    }, 0);
    const shipping = shouldAddShippingCost(parcels, items) ? shippingCost.centAmount : 0;
    const total = subtotal + shipping;
    return {
        subtotal: getEurosFromCentAmount(subtotal),
        shipping: getEurosFromCentAmount(shipping),
        total: getEurosFromCentAmount(total),
    };
};
export const getParcelNumberByOrder = (orderDetails) => JSON.parse(get(orderDetails, 'deliveries[0].parcels[0].trackingData.providerTransaction', ''))
    .parcelNumber;
export const getParcelNumber = (parcel) => JSON.parse(get(parcel, ['trackingData', 'providerTransaction']))?.parcelNumber;
export const getParcelByNumber = (parcels, parcelNumber) => find(parcels, (parcel) => getParcelNumber(parcel) === parcelNumber);
export const downloadPDF = (pdfBytes, fileName = PDF_FILE_NAME) => {
    const pdfBlob = new Blob([pdfBytes.buffer], {
        type: 'application/pdf',
    });
    const pdfURL = URL.createObjectURL(pdfBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = pdfURL;
    downloadLink.download = fileName;
    downloadLink.click();
    URL.revokeObjectURL(pdfURL);
};
export const getHeroTitle = (routeName, t) => {
    switch (routeName) {
        case StepRoutes.END_STEP_SUCCESS:
            return t('returnForm_successHero_header');
        case StepRoutes.END_STEP_FAIL:
            return t('returnForm_errorHero_header');
        default:
            return t('returnForm_hero_title');
    }
};
export const isItemReasonFilled = ({ [FormikFields.RETURN_REASON_CODE]: reasonCode, [FormikFields.RETURN_REASON_OTHER]: otherReasonText, }) => isReasonOther(reasonCode) ? Boolean(trim(otherReasonText)) : isNumber(reasonCode);
const isReasonOther = (reasonCode) => reasonCode === OTHER_REASON_CODE;
const bytesToKBytes = (bytes) => round(bytes / 1000, 0);
const bytesToMBytes = (bytes) => round(bytes / 1000000, 1);
export const getPdfSizeLabel = (pdfSizeBytes) => {
    const kb = bytesToKBytes(pdfSizeBytes);
    return kb > 1000 ? `${bytesToMBytes(pdfSizeBytes)}mb` : `${kb}kb`;
};
